<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()" v-if="false">
            返回投票列表
          </el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            @click="exportExcel()"
            v-show="questionnaireResults.length > 0"
            size="small"
            plain
          >
            导出
          </el-button>
        </div>
      </div>
      <div class="table-block" style="border-top: 0px">
        <el-empty
          description="暂无数据"
          v-show="questionnaireResults.length === 0"
        ></el-empty>
        <el-collapse
          v-model="activeNames"
          @change="handleChange"
          v-show="questionnaireResults.length > 0"
        >
          <el-collapse-item
            :title="item.QuestionnaireName"
            :name="item.QuestionnaireId"
            v-for="(item, index) in questionnaireResults"
            :key="index"
          >
            <el-table
              :data="item.AnswerPaperList"
              highlight-current-row
              style="width: 100%"
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
                v-if="!is_xs"
              >
              </el-table-column>
              <el-table-column property="UserName" label="用户" min-width="200">
              </el-table-column>
              <el-table-column label="是否提交" width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsSubmit" style="color: #67c23a">
                    <i class="el-icon-document-checked"></i>
                    已提交
                  </span>
                  <span v-if="!scope.row.IsSubmit">
                    <i class="el-icon-document-delete"></i>
                    未提交
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" width="130" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.SubmitDateTime">
                    {{
                      scope.row.SubmitDateTime | dateformat('YYYY.MM.DD HH:mm')
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="得分"
                width="130"
                align="center"
                v-if="item.QuestionnaireType === 1"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.AnswerTotalScore >= item.PassScore"
                    style="color: #ff6a00; font-size: 18px; font-weight: bold"
                  >
                    {{ scope.row.AnswerTotalScore }}
                  </span>
                  <span
                    v-if="scope.row.AnswerTotalScore < item.PassScore"
                    style="color: red; font-size: 18px; font-weight: bold"
                  >
                    {{ scope.row.AnswerTotalScore }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import questionnaireApi from '../../../../api/wj/questionnaire'
export default {
  name: 'ResultsSummary',
  components: {
  },
  data () {
    return {
      activeNames: [],
      questionnaireResults: [],
      meetingInfo: {}
    }
  },
  methods: {
    handleChange (val) {
      // console.log(val);
    },
    goBack: function () {
      this.$router.push({ name: 'questionnaireManage', params: { mid: this.$route.params.mid } })
    },
    refresh: function () {
      this.getQuestionnaireResults()
    },
    getQuestionnaireResults: function () {
      const _this = this
      _this.openLoading()
      questionnaireApi.getQuestionnaireResults({
        mettingId: _this.$route.params.mid
      }).then(data => {
        _this.questionnaireResults = data
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    exportExcel: function () {
      const _this = this
      const openLoading = _this.openLoading('正在导出…')
      questionnaireApi.exportQuestionnaireResults({
        MettingId: _this.$route.params.mid
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '问卷汇总'
        if (_this.meetingInfo.MeetingName) {
          fileName = _this.meetingInfo.MeetingName + '-问卷汇总'
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getMeetingVoteInfo: function () {
      this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: this.$route.params.mid
      })
        .then(data => {
          this.meetingInfo = data
        }).catch(err => {
          return err
        })
    }
  },
  computed: {

  },
  created () {
    this.getQuestionnaireResults()
    this.getMeetingVoteInfo()
  }
}
</script>
<style lang="less">
.el-collapse-item__header {
  height: 28px;
  line-height: 28px;
  background-color: #ff6600;
  padding: 0px 10px;
  font-weight: 700;
}
.el-collapse-item__header i {
  color: #fff;
  font-weight: 700;
}
</style>
